import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { timeAgo } from "@/lib/format";
import { typeMeta } from "./notificationMeta";

// AI previews show the generated image; other types fall back to their icon tile.
export default function NotificationRow({ item, onOpen, size = "md", testId }) {
  const meta = typeMeta(item.type);
  const Icon = meta.icon;
  const thumb = size === "lg" ? "h-16 w-20 sm:h-[72px] sm:w-24" : "h-14 w-[4.5rem]";
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => onOpen(item)}
      className={cn(
        "w-full flex items-center gap-4 px-5 py-3.5 text-left transition-colors hover:bg-secondary/60 focus-visible:outline-none focus-visible:bg-secondary/60",
        !item.read && "bg-accent/[0.03]",
      )}
    >
      {item.imageUrl ? (
        <img src={item.imageUrl} alt="" loading="lazy" className={cn("rounded-xl object-cover shrink-0 bg-secondary", thumb)} />
      ) : (
        <span className={cn("rounded-xl flex items-center justify-center shrink-0", thumb, meta.tile)}>
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </span>
      )}
      <span className="flex-1 min-w-0">
        <span className={cn("block text-[15px] text-foreground truncate", item.read ? "font-normal" : "font-medium")}>{item.title}</span>
        <span className="block text-sm text-muted-foreground truncate">{item.subtitle}</span>
        <span className="block text-xs text-muted-foreground/80 mt-0.5">{timeAgo(item.timestamp)}</span>
      </span>
      <span className={cn("h-2.5 w-2.5 rounded-full shrink-0", item.read ? "bg-transparent" : "bg-accent")}>
        <span className="sr-only">{item.read ? "" : "Unread"}</span>
      </span>
      <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
    </button>
  );
}
